<template>
  <div class="project-form">
    <el-form ref="form" :model="projectDynamicForm">
      <!-- 防水项目名称选择 -->
      <el-form-item label="防水项目名称">
        <div style="display: flex; align-items: center;">
          <!-- 输入防水项目名称 -->
          <el-input v-model="projectDynamicForm.name" placeholder="请输入防水项目名称"
            style="flex: 1; min-width: 200px;"></el-input>
        </div>
      </el-form-item>

      <!-- 动态表单配置部分 -->
      <el-form-item label="防水服务阶段">
        <el-card>
          <div v-for="(stage, stageIndex) in projectStages" :key="stageIndex">
            <el-table :data="stage.forms" border style="width: 100%; margin-top: 20px">
              <!-- 服务阶段名称 -->
              <el-table-column prop="stageName" label="服务阶段名称" min-width="50">
                <template v-slot="scope">
                  <el-input v-model="scope.row.stageName" placeholder="请输入服务阶段名称"></el-input>
                </template>
              </el-table-column>
              <!-- 拿货价 -->
              <el-table-column prop="price" label="拿货价" min-width="50">
                <template v-slot="scope">
                  <el-input v-model.number="scope.row.price" type="number" placeholder="请输入拿货价"></el-input>
                </template>
              </el-table-column>
              <!-- 阈值 -->
              <el-table-column prop="threshold" label="阈值" min-width="50">
                <template v-slot="scope">
                  <el-input v-model.number="scope.row.threshold" type="number" placeholder="请输入阈值"></el-input>
                </template>
              </el-table-column>
              <!-- 服务阶段排序 -->
              <el-table-column prop="sort" label="排序" min-width="50">
                <template v-slot="scope">
                  <el-input v-model="scope.row.sort" placeholder="请输入排序"></el-input>
                </template>
              </el-table-column>
              <!-- 动态表单字段配置 -->
              <el-table-column label="表单配置" min-width="900">
                <template v-slot="scope">
                  <el-table :data="scope.row.formFields" border style="width: 100%">
                    <el-table-column label="字段名称">
                      <template v-slot="innerScope">
                        <el-input v-model="innerScope.row.fieldName" placeholder="字段名称"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="控件类型">
                      <template v-slot="innerScope">
                        <el-select v-model="innerScope.row.inputType" placeholder="请选择控件类型">
                          <el-option v-for="type in inputTypes" :key="type.id" :label="type.name"
                            :value="type.id"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column label="数据源">
                      <template v-slot="innerScope">
                        <el-select v-model="innerScope.row.dataSource" placeholder="请选择数据源">
                          <el-option v-for="source in dataSources" :key="source.id" :label="source.valueName"
                            :value="source.id"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <!-- 是否展示showFlag -->
                    <el-table-column label="是否展示" min-width="150">
                      <template v-slot="innerScope">
                        <el-radio-group v-model="innerScope.row.showFlag">
                          <el-radio label="YES">是</el-radio>
                          <el-radio label="NO">否</el-radio>
                        </el-radio-group>
                      </template>
                    </el-table-column>
                    <!-- 下拉多选客户端showClients -->
                    <el-table-column label="客户端" min-width="150">
                      <template v-slot="innerScope">
                        <el-select v-model="innerScope.row.showClient" placeholder="请选择客户端" clearable multiple>
                          <el-option v-for="client in typeClients" :key="client.value" :label="client.label"
                            :value="client.value"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column label="是否为空" min-width="150">
                      <template v-slot="innerScope">
                        <el-radio-group v-model="innerScope.row.isNull">
                          <el-radio label="YES">是</el-radio>
                          <el-radio label="NO">否</el-radio>
                        </el-radio-group>
                      </template>
                    </el-table-column>
                    <!-- 是否计费 -->
                    <el-table-column label="是否计费" width="150">
                      <template v-slot="innerScope">
                        <el-radio-group v-model="innerScope.row.charging">
                          <el-radio label="YES">是</el-radio>
                          <el-radio label="NO">否</el-radio>
                        </el-radio-group>
                      </template>
                    </el-table-column>
                    <el-table-column label="输入计费规则" width="150">
                      <template v-slot="innerScope">
                        <el-input v-model="innerScope.row.expression" placeholder="请输入计费规则" clearable></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="排序" width="150">
                      <template v-slot="innerScope">
                        <el-input v-model="innerScope.row.sort"></el-input>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column label="上传示例图片" align="center">
                      <template v-slot="innerScope">
                        <ImageUpload action="#" :multiple="true" :inTable="true" :limit="1"
                          @uploaded="(urls) => handleUploaded(urls, stageIndex, innerScope.$index)"
                          :uploaded-images="innerScope.row.picUrl" />
                      </template>
                    </el-table-column> -->
                    <el-table-column align="center" label="操作" width="200">
                      <template v-slot="innerScope">
                        <el-button type="text" size="small"
                          @click="removeField(stageIndex, innerScope.$index)">删除字段</el-button>
                        <el-button type="text" size="small" @click="addField(stageIndex)">增加字段</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
              <!-- 删除阶段 -->
              <el-table-column align="center" label="操作" width="150">
                <template v-slot>
                  <el-button type="text" size="small" @click="removeStage(stageIndex)">删除阶段</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-form-item align="center">
            <el-button type="text" icon="el-icon-plus" size="small" @click="addStage">增加阶段</el-button>
          </el-form-item>
        </el-card>
      </el-form-item>
      <!-- 提交按钮 -->
      <el-form-item align="center">
        <el-button type="text" icon="el-icon-close" @click="handleCancel">取消</el-button>
        <el-button type="text" icon="el-icon-plus" @click="submit">新增</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
// import { findEngineeringProjectAll, findEngineeringDynamicId, findDataSourceAll, findDataSourceFields, addDynamic } from "@/api/work/projectDynamic";
import { findDataSourceAll, findDataSourceFields, addDynamic } from "@/api/work/waterProof/projectDynamic";

import ImageUpload from "@/components/imageUpload/ImageUpload";

export default {
  name: 'AddForm',
  components: {
    ImageUpload,
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    projectId: {
      type: String,
      default: ''
    },
    agentId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      projectDynamicForm: { name: '' },
      projectStages: [{
        forms: [{
          stageName: '',
          price: '',
          threshold: '',
          sort: '',
          formFields: [{
            fieldName: '',
            inputType: '',
            dataSource: '',
            showClient: '',
            charging: '',
            expression: '',
            sort: '',
            isNull: '',
            // picUrl: []
          }]
        }]
      }],
      typeClients: [
        {
          label: "工程师端",
          value: "JOINS_ENGINEER",
        },
        {
          label: "消费者端",
          value: "JOINS_USER",
        },
        {
          label: "商户端",
          value: "JOINS_MERCHANT",
        }
      ],
      inputTypes: [],
      dataSources: [],
      additionalFields: {}, // 用于存储其他字段
    };
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal) {
          this.initForm();
        }
      },
      immediate: true
    }
  },
  created() {
    // 获取输入控件类型
    findDataSourceFields().then(res => {
      this.inputTypes = JSON.parse(res.data);
    });

    // 获取数据源
    findDataSourceAll().then(res => {
      this.dataSources = JSON.parse(res.data).rows;
    });
  },
  methods: {
    // 更新图片成功
    handleUploaded(urls, stageIndex, fieldIndex) {
      if (this.projectStages[stageIndex] && this.projectStages[stageIndex].forms[0].formFields[fieldIndex]) {
        this.projectStages[stageIndex].forms[0].formFields[fieldIndex].picUrl = urls;
      }
    },
    // 增加一个阶段
    addStage() {
      this.projectStages.push({
        id: '',
        forms: [{
          stageName: '',
          price: '',
          threshold: '',
          sort: '',
          formFields: [{
            fieldName: '',
            inputType: '',
            dataSource: '',
            showClient: '',
            charging: '',
            expression: '',
            sort: '',
            isNull: '',
            // picUrl: [],
          }]
        }]
      });
    },
    // 删除一个阶段
    removeStage(stageIndex) {
      this.projectStages.splice(stageIndex, 1);
    },
    // 增加一个字段
    addField(stageIndex) {
      this.projectStages[stageIndex].forms[0].formFields.push({
        fieldName: '',
        inputType: '',
        dataSource: '',
        isNull: '',
        showClient: '',
        charging: '',
        expression: '',
        sort: '',
        // picUrl: [],
      });
    },
    // 删除一个字段
    removeField(stageIndex, fieldIndex) {
      this.projectStages[stageIndex].forms[0].formFields.splice(fieldIndex, 1);
    },
    // 提交配置
    submit() {
      // 构建请求数据
      let params = {
        name: this.projectDynamicForm.name,
        type: 'WATERPROOF_PROJECT',
        list: this.projectStages.map(stage => ({
          name: stage.forms[0].stageName,
          price: stage.forms[0].price,
          threshold: stage.forms[0].threshold,
          sort: stage.forms[0].sort,
          type: 'WATERPROOF_PROJECT',
          dynamicFormRequest: {
            fields: stage.forms[0].formFields.map(field => ({
              fieldName: field.fieldName,
              inputType: field.inputType,
              dataSource: field.dataSource,
              isNull: field.isNull,
              // picUrl: field.picUrl.map(url => (typeof url === 'string' ? url : url.url)).join(','),
              showClient: field.showClient.join(','), 
              charging: field.charging,
              expression: field.expression,
              sort: field.sort,
            }))
          }
        }))
      };

      // 提交数据
      addDynamic(params).then(res => {
        if (res.code === '200') {
          this.$message.success('新增成功');
          this.$emit('submit-success');
          this.$emit('close');
        } else {
          this.$message.error(res.message || '新增失败');
        }
      }).catch(error => {
        this.$message.error('请求失败: ' + error.message);
      });
    },

    /**
     * @title 取消操作
     */
    handleCancel() {
      this.$emit('close');
    },

    /**
     * @title 初始化表单数据
     */
    initForm() {
      // 重置表单数据
      this.projectDynamicForm = { name: '' };
      this.projectStages = [{
        forms: [{
          stageName: '',
          price: '',
          threshold: '',
          sort: '',
          formFields: [{
            fieldName: '',
            inputType: '',
            dataSource: '',
            isNull: '',
            showClient: '',
            charging: '',
            expression: '',
            sort: '',
            // picUrl: []
          }]
        }]
      }];

      // 重新获取相关数据
      this.getInputTypes();
      this.getDataSource();
    },

    // 获取输入控件类型
    getInputTypes() {
      findDataSourceFields().then(res => {
        this.inputTypes = JSON.parse(res.data);
      });
    },

    // 获取数据源
    getDataSource() {
      findDataSourceAll().then(res => {
        this.dataSources = JSON.parse(res.data).rows;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.project-form {
  padding: 10px;
  max-height: 70vh;
  overflow-y: auto;
}
</style>
